module.exports = __webpack_public_path__ + "assets/img/collect-cards-light1.e42dab47.png";